import { Tab } from 'carbon-components-react';
import React from 'react';
export default {
  Tab,
  React
};